/* global ENV_CONFIG */
import { disableBiSend } from '../bi/bi-core';
import { enableEventLogging } from '../bi/bi-vod';

function setup() {
  if (ENV_CONFIG.disableBi) {
    disableBiSend();
  }
  if (ENV_CONFIG.logBiSend) {
    enableEventLogging();
  }
}

export const setupEnv = () => {
  try {
    setup();
  } catch (er) {
    console.error('Cannot setup environment', er); // eslint-disable-line no-console
  }
};



// WEBPACK FOOTER //
// ./src/shared/env/setup-env.js